import {
  FETCH_SUPPLIER,
  RESET_SUPPLIER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const supplierViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUPPLIER:
      return { data: action.payload };
    case RESET_SUPPLIER:
      return initialState;
    default:
      return state;
  }
};

export default supplierViewReducer;
